import React from 'react'

export default function CoreIcon() {
    return (
        <a href='https://revelationhelpdesk.com/Pricing' target='_blank'><img src='./images/but_cloud.png' className='pr-6' /></a>
    )
}
